import { Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components/macro';

const Wrapper = styled.div`
  position: relative;
  background: ${({ theme }) => `${theme.palette.common.white}`};
  height: 65px;
  display: flex;
  align-items: center;
  padding: 0 50px;
  justify-content: space-between;
`;

const Item = css`
  margin-left: 32px;
  color: ${({ theme }) => `${theme.palette.primary.dark}`};
  font-weight: 700;
  text-decoration: none;

  &:hover,
  &.active {
    color: ${({ theme }) => `${theme.palette.secondary.main}`};
  }
`;

const PlainLink = styled.span`
  ${Item}
  cursor: pointer;
`;

const LinkItem = styled(NavLink)`
  ${Item}
`;

const Title = styled(Typography)`
  color: ${({ theme }) => `${theme.palette.primary.dark}`};
  font-family: ${({ theme }) => `${theme.typography.fontFamily}`};
  font-weight: 600;
  margin-left: 115px;
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const LinksWrapper = styled.div`
  display: flex;
`;

export const NavbarStyles = {
  Wrapper,
  LinkItem,
  Item,
  PlainLink,
  Title,
  LogoWrapper,
  LinksWrapper,
};
